module.exports = __webpack_public_path__ + "static/media/downloaded-esim-android-mweb.b82eefa9.webp";